import { Box } from "@mui/material";
import { IColoredTagGroup, ITags } from "src/api/server/extended-search.types";
import { IChangeFilterTag } from "src/components/pages/search/components/types";
import { handleTags } from "src/components/pages/search/store/actions";
import { CheckboxList } from "./checkbox-list";

interface ITagsList {
    tags: ITags;
    orderedTagGroups: IColoredTagGroup[];
    onClick?: (isChecked: boolean, value: string) => void;
}

export const TagsList = ({ tags, orderedTagGroups, onClick }: ITagsList) => {
    const onTagChange = ({ isChecked, value, isPopular }: IChangeFilterTag) => {
        onClick?.(isChecked, value);
        handleTags({ isChecked, value, isPopular, tagsData: tags });
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
            }}
        >
            {orderedTagGroups.map(tagGroup => (
                <CheckboxList key={tagGroup.color} filterTags={tagGroup.tags} color={tagGroup.color} onChange={onTagChange} />
            ))}
        </Box>
    );
};
